import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft, Home, ArrowRight } from 'lucide-react';

const QuickNav = ({ showHome = true, showBack = true, customActions = [] }) => {
  const navigate = useNavigate();
  
  const goBack = () => {
    window.history.length > 1 ? navigate(-1) : navigate('/');
  };
  
  const goHome = () => {
    navigate('/');
  };
  
  return (
    <div className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-40">
      <div className="flex flex-col space-y-2">
        {/* Custom Actions */}
        {customActions.map((action, index) => (
          <Button
            key={index}
            onClick={action.onClick}
            className={`rounded-full w-12 h-12 shadow-lg ${action.className || 'bg-white hover:bg-gray-100 text-gray-600 border border-gray-200'}`}
            data-testid={`quick-nav-${action.testId || index}`}
          >
            {action.icon}
          </Button>
        ))}
        
        {/* Home Button */}
        {showHome && (
          <Button
            onClick={goHome}
            className="rounded-full w-12 h-12 bg-gradient-to-r from-blue-700 to-blue-800 hover:from-blue-800 hover:to-blue-900 text-white shadow-lg"
            data-testid="quick-nav-home"
          >
            <Home className="h-5 w-5" />
          </Button>
        )}
        
        {/* Back Button */}
        {showBack && (
          <Button
            onClick={goBack}
            className="rounded-full w-12 h-12 bg-white hover:bg-gray-100 text-gray-600 shadow-lg border border-gray-200"
            data-testid="quick-nav-back"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default QuickNav;